import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { ConnectorModel } from "./connectors.model";

export const connectorsStore = createStore({ name: "connectors" }, withEntities<ConnectorModel>(), withRequestsStatus());
